import { useEffect, useRef } from 'react'

const TRAIL = 16

const CursorTrail = () => {
	const dotsRef = useRef([])
	const positions = useRef(
		Array(TRAIL)
			.fill(null)
			.map(() => ({ x: -300, y: -300 }))
	)
	const mouse = useRef({ x: -300, y: -300 })

	useEffect(() => {
		const onMove = (e) => {
			mouse.current = { x: e.clientX, y: e.clientY }
		}

		let raf
		const loop = () => {
			// First dot snaps closest to cursor
			positions.current[0] = {
				x: positions.current[0].x + (mouse.current.x - positions.current[0].x) * 0.5,
				y: positions.current[0].y + (mouse.current.y - positions.current[0].y) * 0.5,
			}
			// Each subsequent dot chases the one ahead with decreasing speed
			for (let i = 1; i < TRAIL; i++) {
				const lag = 0.38 - i * 0.012
				positions.current[i] = {
					x: positions.current[i].x + (positions.current[i - 1].x - positions.current[i].x) * lag,
					y: positions.current[i].y + (positions.current[i - 1].y - positions.current[i].y) * lag,
				}
			}

			dotsRef.current.forEach((dot, i) => {
				if (!dot) return
				const size = Math.max(1.5, 7 - i * 0.35)
				const opacity = ((TRAIL - i) / TRAIL) * 0.55
				dot.style.transform = `translate(${positions.current[i].x - size / 2}px, ${positions.current[i].y - size / 2}px)`
				dot.style.opacity = opacity
				dot.style.width = `${size}px`
				dot.style.height = `${size}px`
			})

			raf = requestAnimationFrame(loop)
		}

		window.addEventListener('mousemove', onMove)
		loop()
		return () => {
			window.removeEventListener('mousemove', onMove)
			cancelAnimationFrame(raf)
		}
	}, [])

	return (
		<div
			className='fixed inset-0 pointer-events-none'
			style={{ zIndex: 9999 }}
			aria-hidden='true'>
			{Array.from({ length: TRAIL }, (_, i) => (
				<div
					key={i}
					ref={(el) => (dotsRef.current[i] = el)}
					className='fixed top-0 left-0 rounded-full'
					style={{
						background:
							i < 4
								? 'rgba(96,165,250,0.95)'
								: i < 9
								? 'rgba(34,211,238,0.7)'
								: 'rgba(139,92,246,0.4)',
						pointerEvents: 'none',
						willChange: 'transform, opacity',
						boxShadow: i < 3 ? '0 0 4px rgba(96,165,250,0.8)' : 'none',
					}}
				/>
			))}
		</div>
	)
}

export default CursorTrail
